<app-modal title="{{ weekExists() ? 'Edit' : 'Add' }} Employee Rank" #modalComponent>
  <form (submit)="onSubmit($event)" class="p-3" autocomplete="off">

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Rank</label>
      <div class="col-sm-8">
        @for (rank of ranks; track rank) {
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   id="rank"
                   [formField]="employeeRankForm.rank"
                   [value]="rank">
            <label class="form-check-label" for="rank">
              {{ rank | enumParse }}
            </label>
          </div>
        }
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Start date</label>
      <div class="col-sm-8">
        <app-input-date
                [isDisabled]="weekExists()"
                [placeholder]="'Start date'"
                [name]="'date'"
                [inputDate]="formModel().startDate"
                (inputDateChange)="updateStartDate($event)"
                [editDate]="editDate"
                [onlyMondays]="true">
        </app-input-date>
      </div>
    </div>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!isFormValid() || loading()">Save
      </button>
    </div>
  </form>
</app-modal>